// 认证相关API服务
import { httpClient } from '../http';
import { LoginRequest, LoginResponse, UserResponse } from '@/types/api';

export class AuthAPI {
  // 用户登录
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    try {
      const response = await httpClient.post<LoginResponse>('/admin/login', credentials);
      
      // 保存token和用户信息到localStorage
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
      }
      if (response.data.user) {
        localStorage.setItem('userInfo', JSON.stringify(response.data.user));
      }
      
      return response.data;
    } catch (error: any) {
      // 重新抛出错误，让上层处理
      throw error;
    }
  }

  // 获取当前用户信息
  async getCurrentUser(): Promise<UserResponse> {
    // 从localStorage获取存储的用户信息
    const userInfo = localStorage.getItem('userInfo');
    if (!userInfo) {
      throw new Error('用户信息不存在，请重新登录');
    }
    
    try {
      return JSON.parse(userInfo);
    } catch (error) {
      // 如果解析失败，清除存储并抛出错误
      this.logout();
      throw new Error('用户信息格式错误，请重新登录');
    }
  }

  // 登出
  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
  }

  // 检查是否已登录
  isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    const userInfo = localStorage.getItem('userInfo');
    return !!(token && userInfo);
  }

  // 验证token有效性（可选，用于检查token是否过期）
  async validateToken(): Promise<boolean> {
    try {
      if (!this.isAuthenticated()) {
        return false;
      }
      
      // 这里可以调用一个验证token的接口
      // 目前简单检查localStorage中的数据
      const userInfo = await this.getCurrentUser();
      return !!userInfo;
    } catch (error) {
      return false;
    }
  }
}

// 导出单例实例
export const authAPI = new AuthAPI();
